import { apiGet } from '../utils';

const getLoginUrl = async () => {
    const url = `${process.env.REACT_APP_API_URL}/api/login`;
    return await apiGet(url);
};

const getToken = async (params) => {
    const url = `${process.env.REACT_APP_API_URL}/api/token?queryString=${params}`;
    const options = {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
        }
    };
    const response = await fetch(url, options);
    if (response.ok) {
        try {
            const isJson = response.headers.get('content-type')?.includes('application/json');
            console.log(`Received token response: ${response.status} isJSON:${isJson}`);
            if (isJson) {
              // the response is not normally JSON as we usually use a cookie and just return 200 OK without a body
              const json = await response.json();
              return json.bearerAccessToken ? json.bearerAccessToken.value : response.ok;
            } else {
              // if there is no json body, we expect the token has been added to a http only cookie which is not
              // detectable by javascript.
              return response.ok;
            }

        } catch (err) {
            console.error('No expected token response, you could be using the wrong backend, proceeding without token: ', response.status, err, JSON.stringify(err))
            return response.ok
        }
    } else {
        return false;
    }
};

const getUserInfo = async() => {
    const url = `${process.env.REACT_APP_API_URL}/api/user/info`;
    return await apiGet(url);
};

export {
    getLoginUrl,
    getToken,
    getUserInfo,
};
